class RootPaddingX {
  private tailwindValue: number = 5
  constructor() {}

  get px(): string {
    return `px-${this.tailwindValue}`
  }
  get cmx(): string {
    return `-mx-${this.tailwindValue}`
  }
  addingPx(add: number): string {
    return `px-${this.tailwindValue + add}`
  }
  addingCmx(add: number): string {
    return `px-${this.tailwindValue + add}`
  }
}
export const rootPx = new RootPaddingX()
